import type { RequestDetailData, RequestOfferEvaluation } from "../../../domain/request-detail-types";

export function requestDecisionPresentation(detail: RequestDetailData | null, evaluation: RequestOfferEvaluation | null, decisionOfferId: string) {
const selectedDecisionOffer =
    evaluation?.offers.find((offer) => offer.id === decisionOfferId) ?? null;
const systemDecisionOffer =
    evaluation?.offers.find((offer) => offer.id === evaluation.topOfferId) ??
    null;
const systemDecisionCommercialOffer =
    detail?.offers.find((offer) => offer.id === systemDecisionOffer?.id) ??
    null;
const systemDecisionRunnerUp = evaluation
    ? ([...evaluation.offers]
        .filter(
          (offer) =>
            offer.id !== evaluation.topOfferId &&
            !offer.exclusionReasons.length,
        )
        .sort(
          (left, right) =>
            (right.totalScore ?? -1) - (left.totalScore ?? -1) ||
            left.offerNo.localeCompare(right.offerNo, "tr"),
        )[0] ?? null)
    : null;
const systemDecisionScoreGap =
    systemDecisionOffer?.totalScore !== null &&
    systemDecisionOffer?.totalScore !== undefined &&
    systemDecisionRunnerUp?.totalScore !== null &&
    systemDecisionRunnerUp?.totalScore !== undefined
      ? Math.max(
          0,
          Math.round(
            systemDecisionOffer.totalScore - systemDecisionRunnerUp.totalScore,
          ),
        )
      : null;
const systemRecommendationStrengths = systemDecisionOffer
    ? [
        systemDecisionOffer.amountScore === 100 ? "toplam maliyet" : null,
        systemDecisionOffer.deliveryScore === 100 ? "teslimat süresi" : null,
        systemDecisionOffer.paymentScore === 100 ? "ödeme vadesi" : null,
        systemDecisionOffer.performanceScore === 100
          ? "tedarikçi performansı"
          : null,
      ].filter((value): value is string => Boolean(value))
    : [];
const systemRecommendationSummary = systemDecisionOffer
    ? `${systemDecisionOffer.supplier}, ${systemDecisionOffer.totalScore === null ? "—" : Math.round(systemDecisionOffer.totalScore)} puanla ilk sırada. ${
        systemRecommendationStrengths.length
          ? `${systemRecommendationStrengths.join(", ")} kriterlerinde en güçlü teklif.`
          : "Fiyat, teslimat, vade ve kanıtlı performansın ağırlıklı sonucunda en dengeli teklif."
      }`
    : "Sistem önerisi oluşturulamadı.";
const systemRecommendationMetrics = systemDecisionOffer
    ? [
        {
          label: "Toplam bedel",
          value: systemDecisionCommercialOffer?.formattedAmount ?? "—",
          score: systemDecisionOffer.amountScore,
        },
        {
          label: "Teslimat",
          value: systemDecisionCommercialOffer
            ? `${systemDecisionCommercialOffer.delivery_days} gün`
            : "—",
          score: systemDecisionOffer.deliveryScore,
        },
        {
          label: "Ödeme vadesi",
          value: systemDecisionCommercialOffer
            ? `${systemDecisionCommercialOffer.payment_days} gün`
            : "—",
          score: systemDecisionOffer.paymentScore,
        },
        {
          label: "Geçmiş performans",
          value:
            systemDecisionOffer.performanceScore === null ||
            systemDecisionOffer.performanceScore === undefined
              ? "Veri yok"
              : `${Math.round(systemDecisionOffer.performanceScore)}/100`,
          score: systemDecisionOffer.performanceScore,
        },
      ]
    : [];
const rationalePrompts = selectedDecisionOffer
    ? [
        {
          label: "Fiyat avantajı",
          text: `Fiyat ve toplam maliyet açısından ${selectedDecisionOffer.supplier} teklifini uygun buldum.`,
        },
        {
          label: "Teslimat uygunluğu",
          text: "Teslimat koşulları operasyonun ihtiyaç tarihini destekliyor.",
        },
        {
          label: "Vade avantajı",
          text: "Ödeme vadesi ve ticari koşullar nakit akışı açısından uygun.",
        },
        {
          label:
            decisionOfferId === evaluation?.topOfferId
              ? "Sistemle uyumlu"
              : "Operasyonel tercih",
          text:
            decisionOfferId === evaluation?.topOfferId
              ? "Sistem sıralamasıyla uyumlu olduğu için bu teklifi öneriyorum."
              : "Sistem önerisinden farklı olarak operasyonel gereksinimler nedeniyle bu teklifi öneriyorum.",
        },
      ]
    : [];
return { selectedDecisionOffer, systemDecisionOffer, systemDecisionCommercialOffer, systemDecisionRunnerUp, systemDecisionScoreGap, systemRecommendationStrengths, systemRecommendationSummary, systemRecommendationMetrics, rationalePrompts };
}
